import { useDispatch } from 'react-redux';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { getActivityData } from '../utils/getActivityData';
import { resetState } from '../utils/resetState';
import { getTrackingObjContainer } from '../utils/getTrackingObjContainer';
import { setMyCarsData as setMyCarsDataAction } from '../actions/setMyCarsData';
import { MY_CARS_KEY } from '../global-constants';

/**
 * Decides two things My Cars' content needs: whether to show the
 * "welcome back" version instead of "start shopping" (welcome: true if the
 * user has any tracked/saved/viewed activity), and what a link click does
 * (fire a tracking event, then clear the new-activity badge counts). Both
 * MyCarsModal and Widget's inline-content mode call this same hook, so they
 * can't compute or handle clicks differently from each other.
 */
export const useMyCarsContentActions = (myCarsData) => {
	const dispatch = useDispatch();
	const { windowId, widgetName } = useRequestData();
	const labels = useLabels();
	const trackingObjContainer = getTrackingObjContainer({
		RECENTLY_VIEWED: labels.get('RECENTLY_VIEWED'),
		TRACKING_PRICE: labels.get('TRACKING_PRICE'),
		SAVED: labels.get('SAVED'),
		SHOP_OUR_INVENTORY: labels.get('SHOP_OUR_INVENTORY')
	});
	const { totalActivityCount } = getActivityData(myCarsData?.vehicles);

	const onClickHandler = (title, url) => {
		const trackingObj = trackingObjContainer[title];
		trackingObj.url = url;
		trackEvent(widgetName, windowId, trackingObj);
		dispatch(setMyCarsDataAction(resetState(myCarsData, MY_CARS_KEY)));
	};

	return {
		welcome: totalActivityCount > 0,
		onClickHandler
	};
};
